<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>
  <p-confirmdialog />
  <p-card>
    <ng-template #title>
      <h1>{{ 'content.announcements.title' | translate }}</h1>
    </ng-template>

    <div class="flex justify-end gap-2 mb-5">
      <p-button
        icon="fa fa-plus"
        [label]="'content.announcements.add' | translate"
        (onClick)="navigateToCreate()"
      />
    </div>

    <p-table
      [value]="service.items()"
      stripedRows
      showGridlines
      dataKey="id"
      [paginator]="true"
      [rows]="25"
      [rowsPerPageOptions]="[25, 50, 75, 100]"
      [scrollable]="true"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template #header>
        <tr>
          <th>{{ 'content.announcements.fields.headline' | translate }}</th>
          <th>{{ 'content.announcements.fields.type' | translate }}</th>
          <th class="text-right">
            {{ 'content.announcements.fields.rank' | translate }}
          </th>
          <th>{{ 'content.announcements.fields.validFrom' | translate }}</th>
          <th>{{ 'content.announcements.fields.validUntil' | translate }}</th>
          <th>{{ 'content.announcements.fields.status' | translate }}</th>
          <th pFrozenColumn alignFrozen="right" class="w-32"></th>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr class="cursor-pointer" (click)="navigateToDetail(row)">
          <td>{{ row.headline || '—' }}</td>
          <td>
            <p-tag
              severity="info"
              [value]="'content.announcements.types.' + row.type | translate"
            />
          </td>
          <td class="text-right">{{ row.rank }}</td>
          <td>
            {{
              row.valid_from
                ? (row.valid_from | date: 'dd.MM.yyyy HH:mm' : 'Europe/Berlin')
                : '—'
            }}
          </td>
          <td>
            {{
              row.valid_until
                ? (row.valid_until | date: 'dd.MM.yyyy HH:mm' : 'Europe/Berlin')
                : '—'
            }}
          </td>
          <td>
            <p-tag
              [severity]="statusSeverity(row)"
              [value]="
                'content.announcements.status' + statusOf(row) | translate
              "
            />
          </td>
          <td pFrozenColumn alignFrozen="right">
            <div class="flex items-center justify-end gap-2">
              <p-button
                type="button"
                icon="fa fa-pencil"
                [text]="true"
                [rounded]="true"
                severity="secondary"
                [ariaLabel]="'label.edit' | translate"
                (onClick)="navigateToDetail(row); $event.stopPropagation()"
              />
              <p-button
                type="button"
                icon="fa fa-trash"
                [text]="true"
                [rounded]="true"
                severity="secondary"
                [ariaLabel]="'label.delete' | translate"
                (onClick)="onRowDelete($event, row); $event.stopPropagation()"
              />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="7" class="text-center italic text-color-secondary py-6">
            {{ 'content.announcements.empty' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
